import { Linktrainrelaymixer } from '@linktivity/eticketportal';
import { message } from '@linktivity/link-ui';

const config = new Linktrainrelaymixer.Configuration({
  basePath: import.meta.env.VITE_API_EMOT_HOST,
  middleware: [
    {
      pre: async context => {
        context.init.headers = new Headers({
          'Content-Type': 'application/json'
        });
      },
      post: async context => {
        if (!context.response.ok) {
          const data = await context.response.json();
          message.error(
            data.common?.error_description || data.common?.error_code,
            10
          );
        }
      }
    }
  ]
});

const linktrainrelay = new Linktrainrelaymixer.LinktrainrelaymixerApi(config);

export default linktrainrelay;
